import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from "@angular/core";

@Component({
  selector: 'gen-section-expander',
  templateUrl: './section-expander.component.html',
  styleUrls: ['./section-expander.component.scss', '../text-viewer/entity-colors.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SectionExpanderComponent {

  @Input() header: string;
  @Input() body: string;
  @Input() visible: boolean = false;

  constructor() {
  }
}
